import {
  BUILD_ENV,
  GIT_VERSION,
  DATADOG_PROXY,
  DATADOG_CLIENT_TOKEN,
  DATADOG_APPLICATION_ID,
  DATADOG_SESSION_SAMPLE_RATE
} from 'gatsby-env-variables'

import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import isClient from '../../../utils/envs/isClient'
import storage from '../../../utils/storage'

const leadId = isClient() && (storage.session.getItem('token')?.leadId ?? '')

const init = () => {
  const version = {
    ...(BUILD_ENV === 'production' ? { version: GIT_VERSION } : {})
  }

  const proxy = {
    ...(DATADOG_PROXY ? { proxy: DATADOG_PROXY } : {})
  }

  datadogRum.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    applicationId: DATADOG_APPLICATION_ID,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'JN6-Loans',
    env: `${BUILD_ENV}`,
    ...version,
    ...proxy,
    sessionSampleRate: DATADOG_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    actionNameAttribute: 'datadog-action'
  })
}

const logsInit = () => {
  const version = {
    ...(BUILD_ENV === 'production' ? { version: GIT_VERSION } : {})
  }

  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'itau-jn6-app-loans-www',
    env: `${BUILD_ENV}`,
    ...version,
    forwardConsoleLogs: ['warn', 'error']
  })
}

const logsError = {
  recaptchaError: (err) => {
    datadogLogs.logger.error(
      'Recaptcha Error',
      {
        leadId
      },
      err
    )
  }
}

const logsWarn = {
  heroEmpty: () => {
    datadogLogs.logger.warn('HeroEmpty', {
      leadId
    })
  },
  emptyOffers: () => {
    datadogLogs.logger.warn('EmptyOffers', {
      leadId
    })
  },
  unexpectedValues: (unexpectedValues, errorMessage) => {
    const unexpectedValuesLog = {
      leadId,
      unexpectedValues
    }

    datadogLogs.logger.warn(
      'UnexpectedValues',
      unexpectedValuesLog,
      errorMessage
    )
  },
  unexpectedPath: (path, resolvedPath) => {
    const unexpectedPathLog = {
      path,
      leadId,
      resolvedPath
    }

    datadogLogs.logger.warn('UnexpectedPath', unexpectedPathLog)
  },
  itiAgency: () => {
    datadogLogs.logger.warn('itiAgency', {
      leadId
    })
  }
}

export default {
  init,
  logsInit,
  logsWarn,
  logsError
}
